import { render, staticRenderFns } from "./wTable2.vue?vue&type=template&id=b8b4413a&"
import script from "./wTable2.vue?vue&type=script&lang=js&"
export * from "./wTable2.vue?vue&type=script&lang=js&"
import style0 from "./wTable2.vue?vue&type=style&index=0&id=b8b4413a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports